import { openWildixModal } from '../../components/base/modal';
import PopupPassword from '../../components/modals/PopupPassword';
import WizyPopupPassword from '../../components/modals/WizyPopupPassword';
import Env from '../../modules/Environment';

if (Env.isWizyconf() && typeof APP === 'object') {
    APP.store.dispatch(openWildixModal({
        id: 'wizy-password-modal',
        component: WizyPopupPassword,
        props: { dispatch: APP.store.dispatch,
            conference: APP.conference.__getJitsiConference() }
    }));
} else if (typeof APP === 'object') {
    APP.store.dispatch(openWildixModal({
        id: 'password-modal',
        component: PopupPassword,
        props: { dispatch: APP.store.dispatch,
            conference: APP.conference.__getJitsiConference() }
    }));
}
